<script>
import {useModal} from "vue-final-modal";
import Modal from "$vueCommon/components/Modal.vue";
import IdentityAddEdit from "$vueCommon/components/Cart/IdentityAddEdit.vue";

export default {
    props: {
        identities: Array,
        selected: Object,
        buttonAddText: String,
        saving: Boolean,
        identityType: String,
        requiredFields: {
            type: Array,
            default: () => []
        }
    },
    emits: ['onSelected', 'onEdited'],
    data() {
        return {
            localSelectedIdentity: {}
        }
    },
    mounted() {
        this.localSelectedIdentity = this.selected;
    },
    computed: {
        identitiesList() {
            if (!Array.isArray(this.identities)) {
                return [];
            }

            return this.identities.map(identity => {
                identity.is_business = (!!identity.company_name && identity.company_name.trim().length > 0) || (!!identity.tax_id && identity.trim().length > 0);

                const parts = [];

                if (!identity.is_business) {
                    parts.push(identity.first_name + ' ' + identity.last_name);
                } else {
                    parts.push(identity.company_name);
                }

                const address = [];
                if (identity.address) {
                    address.push(identity.address);
                }

                if (identity.address2) {
                    address.push(identity.address2);
                }

                if (address.length) {
                    parts.push(address.join(' '));
                }

                if (identity.city) {
                    parts.push((identity.postal_code ? identity.postal_code + ' ' : '') + identity.city);
                }

                identity.label = parts.join(', ');

                return identity;
            });
        }
    },
    methods: {
        addIdentity() {
            let that = this;
            let identity = {};
            const {open, close} = useModal({
                component: Modal,
                attrs: {
                    title: 'Add new address',
                    size: 'lg',
                    onConfirm() {
                        close();
                    }
                },
                slots: {
                    default: {
                        component: IdentityAddEdit,
                        attrs: {
                            identity: identity,
                            onConfirm: function (identityId) {
                                that.selectIdentity(identityId);
                                that.$emit('onEdited', identityId);
                                close();
                            },
                            onDismiss: function () {
                                close();
                            },
                            identityType: that.identityType,
                            actionType: 'add',
                            requiredFields: that.requiredFields
                        }
                    }
                }
            });
            open();
        },
        editIdentity(identity = {}) {
            let that = this;
            const {open, close} = useModal({
                component: Modal,
                attrs: {
                    title: 'Edit address',
                    size: 'lg',
                    onConfirm() {
                        close();
                    }
                },
                slots: {
                    default: {
                        component: IdentityAddEdit,
                        attrs: {
                            identity: identity,
                            onConfirm: function (identityId) {
                                that.selectIdentity(identityId);
                                that.$emit('onEdited', identityId);
                                close();
                            },
                            onDismiss: function () {
                                close();
                            },
                            identityType: that.identityType,
                            actionType: 'edit',
                            requiredFields: that.requiredFields
                        }
                    }
                }
            });
            open();
        },
        onIdentitySelected(identity) {
            if (!identity) {
                return;
            }

            if (!this.selected || this.selected.id !== identity.id) {
                this.$emit('onSelected', identity);
            }
        },
        selectIdentity(identityId) {
            this.identities.forEach(identity => identity.id === identityId ? this.localSelectedIdentity = identity : null);
            this.onIdentitySelected();
        }
    },
    watch: {
        'selected': function () {
            this.localSelectedIdentity = this.selected;
        },
        localSelectedIdentity(newVal, oldVal) {
            this.onIdentitySelected(newVal);
        }
    }
}
</script>
<template>
    <div class="component-select-identity">
        <vselect v-if="identitiesList.length > 0"
            :options="identitiesList"
            v-model="localSelectedIdentity"
            :clearable="false"
            :searchable="false">
            <template #selected-option="{ label, is_business }">
                <span>
                    <span v-if="!is_business"><i class="fa fa-user"></i></span>
                    <span v-if="is_business"><i class="fa fa-building"></i></span>
                    {{ label }}
                </span>
            </template>
            <template #option="{ label, is_business, ...option }">
                <span>
                    <span v-if="!is_business"><i class="fa fa-user"></i></span>
                    <span v-if="is_business"><i class="fa fa-building"></i></span>
                    {{ label }}
                </span>
                <button @click.stop="editIdentity(option)" class="btn btn-sm">
                    {{ $translate('checkout.edit') }}
                </button>
            </template>
            <template v-slot:list-footer="footer">
                <button @click="addIdentity()" class="btn btn-sm">
                    <span v-if="buttonAddText">{{ buttonAddText }}</span>
                    <span v-if="!buttonAddText">{{ $translate('checkout.add_identity') }}</span>
                </button>
            </template>
        </vselect>
        <div v-if="identitiesList.length === 0">
            <button @click="addIdentity()">
                <span v-if="buttonAddText">{{ buttonAddText }}</span>
                <span v-if="!buttonAddText">{{ $translate('checkout.add_identity') }}</span>
            </button>
        </div>
    </div>
</template>
